'use strict';

var _extends = require('../../node_modules/@babel/runtime/helpers/extends.js');
var React = require('react');
var IconButton = require('../../DesignSystem/Inputs/Buttons/IconButton.js');
var KanbanMenuItems = require('./KanbanMenuItems.js');
var Menu = require('../../DesignSystem/Navigation/Menus/Menu.js');
var MoreVert = require('../../IconsAndImages/Icons/MoreVert.js');
var index = require('../../node_modules/material-ui-popup-state/index.js');
var classNames = require('classnames');
require('prop-types');
var index$1 = require('../../_virtual/index.js_commonjs-exports.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var KanbanHeaderActions = function KanbanHeaderActions(_ref) {
  var variant = _ref.variant,
      left = _ref.left,
      right = _ref.right;
  var isSmallVariant = variant === 'small';
  return React__default["default"].createElement("div", {
    className: classNames__default["default"]('headerActions', {
      empty: !left && !right
    })
  }, !!left && React__default["default"].createElement("div", {
    className: 'left'
  }, left), !!right && React__default["default"].createElement("div", {
    className: classNames__default["default"]('right', {
      small: isSmallVariant
    })
  }, isSmallVariant && Array.isArray(right) ? React__default["default"].createElement(index, {
    variant: "popover",
    popupId: "demo-popup-menu"
  }, function (popupState) {
    return React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement(IconButton, index$1.__exports.bindTrigger(popupState), React__default["default"].createElement(MoreVert, null)), React__default["default"].createElement(Menu, _extends["default"]({
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    }, index$1.__exports.bindMenu(popupState)), React__default["default"].createElement(KanbanMenuItems, {
      close: popupState.close
    }, right)));
  }) : right));
};

KanbanHeaderActions.defaultProps = {
  left: null,
  right: null,
  variant: 'standard'
};

module.exports = KanbanHeaderActions;
